<template>
  <v-row>
    <v-col cols="12">
      <p class="subtitle-2" v-if="parametrage.campagnePrecoce">
        La campagne de modification d'inscription administrative (MIA) commence
        le {{ dateDebut }} et se termine le {{ dateFin }}
      </p>
      <p v-else class="subtitle-2">
        La Réorientation vers un semestre 2 commence le {{ dateDebut }}<br />
        La date de fin de la réorientation est différente d'une formation à
        l'autre (<a
          href="https://nextcloud.univ-lille.fr/index.php/s/FmjFzd3i7oBC8iE/download/R%C3%A9orientation-Formations-ouvertes.pdf"
          >voir liste des formations ouvertes</a
        >)
      </p>
    </v-col>
  </v-row>
</template>
<script>
import moment from "moment";

export default {
  name: "InfoDates",
  props: { parametrage: Object },
  computed: {
    dateDebut() {
      return this.parametrage.dateOuvertureDefaut
        ? moment(this.parametrage.dateOuvertureDefaut).format("DD/MM/YYYY")
        : "";
    },
    dateFin() {
      return this.parametrage.dateFermetureDefaut
        ? moment(this.parametrage.dateFermetureDefaut).format("DD/MM/YYYY")
        : "";
    }
  }
};
</script>
